export function getFileExt(filename) {
    const regex = /\.([^.]+)$/;
    const match = filename.match(regex);

    return match ? match[1] : null;
}